/* GENERATED BY tools/stage_card_frames.py - DO NOT EDIT.
 *
 * A card's realm (`quadrant`) -> its frame. We made a set per realm and they are the most
 * useful thing on the card: typed Foxfire makes the realm the thing that PAYS for it.
 *
 * `regular` is the board/hand frame; `full` is the large inspect view.
 */
export const CARD_FRAMES: Readonly<Record<string, { regular?: string; full?: string }>> =
  Object.freeze({
    "Domain_of_Negafook": {"full": "/art/frames/full_Domain_of_Negafook.png", "regular": "/art/frames/regular_Domain_of_Negafook.png"},
    "Neutral": {"full": "/art/frames/full_Neutral.png", "regular": "/art/frames/regular_Neutral.png"},
    "The_Ironworks": {"full": "/art/frames/full_The_Ironworks.png", "regular": "/art/frames/regular_The_Ironworks.png"},
    "The_Scorched_Expanse": {"full": "/art/frames/full_The_Scorched_Expanse.png", "regular": "/art/frames/regular_The_Scorched_Expanse.png"},
    "The_Spirit_Veil": {"full": "/art/frames/full_The_Spirit_Veil.png", "regular": "/art/frames/regular_The_Spirit_Veil.png"},
    "The_Verdant_Hollow": {"full": "/art/frames/full_The_Verdant_Hollow.png", "regular": "/art/frames/regular_The_Verdant_Hollow.png"},
  });

/** A realm's colour, declared beside the colour itself in RevivalTheme.cs. */
export const REALM_COLOUR: Readonly<Record<string, string>> = Object.freeze({
  "Domain_of_Negafook": "#6FA8D6",
  "Neutral": "#9FB2AE",
  "The_Ironworks": "#9A8B7A",
  "The_Scorched_Expanse": "#E2622F",
  "The_Spirit_Veil": "#A99BD6",
  "The_Verdant_Hollow": "#6FBF7F",
});
